export const colors = {
  highlight: '#2C81D2',
  highlightText: '#fff',
  textDark: '#42505C',
  text: '#404549',
  textGray: '#53595e',
  textLight: '#f9f9f9',
  cellBorder: '#dae9f7',
  opacShade: 'rgba(0,0,0,0.18)',
  opacShadeLt: 'rgba(0,0,0,0.12)',
  sidebarText: '#717b83',
  headerText: '#3e4047',
  headerIcons: '#90949f',
  headerTabText: '#717b83',
  headerTabBorder: 'rgba(0,0,0,0.1)',
  toolbarItemText: '#7D8891',
  toolbarItemTextHov: '#7D8891',
  toolbarTopText: '#c6cbcf',
  toolbarTopTextHov: '#f9f9f9',
  toolbarTopTextAct: '#7D8891',
  headerMenuBorderLt: 'rgba(255,255,255,0.12)',
  headerMenuBorderDrk: '#C9D3E0',
  panelBorder: '#C9D3E0',
  toolbarTopBorder: 'rgba(0,0,0,0.08)',
  toolbarTopBorderLt: 'rgba(255,255,255,0.3)',
  title: '#fff',
  go: '#16b867',
  goAlt: '#19cf74',
  stop:  '#E62712',
  inactive: '#7D8891',
  error: '#E62712',
  bg: {
    // General
    surface: '#FEFEFE',
    surfaceHov: '#fff',
    bottom: '#abb7c1',
    title: '#445461',
    off: '#4d565d',
    on: '#2C81D2',
    // Panels
    panel: '#f8fbfc',
    panelInput: '#fff',
    // Toolbars
    toolbarItem: 'none',
    toolbarItemAct: '#f0f6f9',
    toolbarItemHov: '#fff',
    // - top
    toolbarTop: '#445461',
    toolbarTopHov: '#fafdfe',
    toolbarTopAct: '#fafdfe',
    // Headers
    header: '#f8fbfc',
    headerHov: '#fff',
    headerAct: '#2C81D2',
    headerMenu: '#f0f6f9',
    headerInput: '#fff',
    headerTab: '#dfe5e8',
    // Sidebar
    sidebar: '#fafdfe',
    sidebarHov: '#445461',
    sidebarAct: '#2C81D2',
    // table rows
    row0: '#fff',
    row1: '#f4faff',
    rowHov: '#e5f4ff',
  }
}
